import { IReduxAction } from '@bees-web/core/types'
import {
  MAX_BRANDS_HEIGHT,
  MAX_GUEST_HEIGHT,
  SET_BRANDS_BANNERS,
  SET_BRANDS_BANNERS_HEIGHT,
  SET_BRANDS_BANNERS_VISIBILITY,
  SET_GUEST_BANNERS_HEIGHT,
  SET_SIGNED_BANNERS,
  SET_SIGNED_BANNERS_META,
} from '../constants/banners'
import { IBannersState } from '../interfaces'

export const initialState: IBannersState = {
  heightGuest: MAX_GUEST_HEIGHT,
  slidesBrands: [],
  heightBrands: MAX_BRANDS_HEIGHT,
  isBrandsLoading: true,
  slidesSigned: [],
  meta: null,
  isInViewHeight: false,
}

const bannersReducer = (
  state: IBannersState = initialState,
  action: IReduxAction
) => {
  switch (action.type) {
    case SET_BRANDS_BANNERS_VISIBILITY:
      return {
        ...state,
        isInViewHeight: action.payload,
      }
    case SET_GUEST_BANNERS_HEIGHT:
    case SET_BRANDS_BANNERS_HEIGHT:
    case SET_SIGNED_BANNERS:
    case SET_SIGNED_BANNERS_META:
      return {
        ...state,
        ...action.payload,
      }

    case SET_BRANDS_BANNERS:
      return {
        ...state,
        ...action.payload,
        isBrandsLoading: false,
      }

    default:
      return state
  }
}

export default bannersReducer
